import {initHamburger} from './modules/hamburger.js';
// import {initHeaderScrolledClass} from './modules/header.js';
import {fadeAnime, delayScrollAnime} from './modules/animation.js';
import {initPageTop} from './modules/page-top.js';
import {initFixedBar} from './modules/fixed-bar.js';

document.addEventListener('DOMContentLoaded', () => {
  initHamburger();
  // initHeaderScrolledClass();
  initPageTop();
  initFixedBar();
});

window.addEventListener('load', () => {
  fadeAnime();
  delayScrollAnime();
});

window.addEventListener('scroll', () => {
  fadeAnime();
  delayScrollAnime();
});
